import React from "react";
import whatsappbot from "../assets/portfolio/whatsappbot.png";
import npmpic from "../assets/portfolio/npm.png";
import resumebuilder from "../assets/portfolio/resumebuilder.png";
import todolistmernstack from "../assets/portfolio/todolistmernstack.png";
import discordbot from "../assets/portfolio/discordbot.png";
import colorpicker from "../assets/portfolio/colorpicker.png";

const Portfolio = () => {
  const Portfolios = [
    {
      id: 1,
      src: whatsappbot,
    },
    {
      id: 2,
      src: npmpic,
    },
    {
      id: 3,
      src: resumebuilder,
    },
    {
      id: 4,
      src: colorpicker,
    },
    {
      id: 5,
      src: discordbot,
    },
    {
      id: 6,
      src: todolistmernstack,
    },
  ];

  return (
    <div
      name="portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white md:h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600">
            Portfolio
          </p>
          <p className="py-6">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
          {Portfolios.map(({ id, src }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
              <img
                src={src}
                alt=""
                className="rounded-md duration-200 hover:scale-105"
              />
              <div className="flex items-center justify-center">
                <a href="https://github.com/Divasraj1">
                  <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                    Demo
                  </button>
                </a>
                <a href="https://github.com/Divasraj1">
                  <button className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                    Code
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
